import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { CoreFormService } from 'src/app/core/forms/core-forms.service';
import { CountriesService } from '../../countries/countries.service';
import { Location } from '@angular/common';
import { ReasonsTransactionsStatusService } from '../reasons-transactions-status.service';

@Component({
  selector: 'app-reasons-transactions-status-detail',
  templateUrl: './reasons-transactions-status-detail.component.html',
  styleUrls: ['./reasons-transactions-status-detail.component.scss']
})
export class ReasonsTransactionsStatusDetailComponent {
  @ViewChild("formDetails") public formDetails: NgForm;
  public reasonTransactionStatus: any = {
    name: ""
  };
  public countries: any[] = [];

  constructor(
    private reasonsTransactionsStatusService: ReasonsTransactionsStatusService,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private coreFormService: CoreFormService,
    private coreDialogService: CoreDialogService,
    private _location: Location,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.loadData(params['id']);
    });
  }

  loadData(id: number) {
    if (id != 0) {
      this.reasonsTransactionsStatusService.get(id).subscribe({
        next: (data: any) => {
          this.reasonTransactionStatus = data;
        },
        error: (error: any) => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      });
    }
  }
  cancel() {
    this.router.navigate(['/configuration/reasonsTransactionsStatus']);
  }

  save() {
    if (this.coreFormService.validate(this.formDetails)) {
      this.reasonsTransactionsStatusService.save(this.reasonTransactionStatus.id, this.reasonTransactionStatus).subscribe({
        next: (data: any) => {
          var _msg = (this.reasonTransactionStatus.id != 0 && typeof this.reasonTransactionStatus.id !== "undefined") ? "save_correct" : "add_correct";
          var aux = this.translateService.instant("component.reasonTransactionStatus.detail." + _msg);
          this.messageService.add({ closable: false, severity: 'success', summary: aux });
          this.router.navigate(['/configuration/reasonsTransactionsStatus']);
        },
        error: (error: any) => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      });
    }
  }

  delete() {
    this.coreDialogService.confirm({
      message: this.translateService.instant("component.reasonTransactionStatus.delete_message", { name: this.reasonTransactionStatus.name }),
      header: this.translateService.instant("general.confirmation_delete_title"),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.reasonsTransactionsStatusService.delete(this.reasonTransactionStatus.id).subscribe({
          next: (res: any) => {
            this.messageService.add({ closable: false, severity: 'success', summary: this.translateService.instant("general.confirmation_delete") });
            this._location.back();
          },
          error: (error: any) => {
            this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
          }
        });
      },
      reject: () => {

      }
    });
  }

  isDuplied() {
    this.save();
    return;
    var errorMessage = "";
    if (this.reasonTransactionStatus.name.length <= 0) {
      this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: this.translateService.instant("general.form_incomplete") });
    }
    this.reasonsTransactionsStatusService.isDuplied(this.reasonTransactionStatus).subscribe(
      data => {
        if (data == true) {
          this.coreDialogService.notify({
            message: this.translateService.instant("component.reasonsTransactionsStatus.detail.types_duplicates"),
            header: 'Error',
            icon: 'far exclamation-circle',
            color: 'var(--orange-500)',
            accept: () => { }
          });
        } else {
          this.save();
        }
      }
    );
  }
}
